import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=2f2f5598&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f5598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2f5598')) {
      api.createRecord('2f2f5598', component.options)
    } else {
      api.reload('2f2f5598', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=2f2f5598&scoped=true&", function () {
      api.rerender('2f2f5598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OhOW12vVVT0e/JS/comp/SearchFilterTokens.vue"
export default component.exports